import ApiUrls from "../../../service/api/ApiUrls";
import StorageKeys from "../../../const/StorageKeys";
import ApiService from "../../../service/api/ApiService";
import ShowToast from "../../../widget/common/ui/Toast";
import CacheStorage from "../../../service/storage/CacheStorage";
import {
  MenuMyMessagesList,
  MyMessagesModel,
} from "../../../model/work_profile/MyMessagesModel";

const MyMessagesProvider = new (class MyMessagesProvider {
  getMessagesAPI = async (): Promise<Array<MenuMyMessagesList> | null> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const url: string = `${ApiUrls.baseUrl}settings/menu/my_messages_list`;

    const body: any = {
      account_id: accountId,
      group_id: "0",
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const myMessagesModel: MyMessagesModel = response;
        const menuMyMessagesList: Array<MenuMyMessagesList> =
          myMessagesModel?.result?.menu_my_messages_list!;

        return menuMyMessagesList;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };

  manageAPI = async (params: {
    group_ids: Array<string>;
    title?: string;
    message?: string;
    flag: "0" | "1" | "2";
  }): Promise<Array<MenuMyMessagesList> | null> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const url: string = `${ApiUrls.baseUrl}settings/menu/manage_my_messages`;

    const body: any = {
      account_id: accountId,
      group_id: params.flag === "0" ? params.group_ids.join(",") : "0",
      title: params.title ?? "",
      message: params.message ?? "",
      flag: params.flag,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const myMessagesModel: MyMessagesModel = response;
        const menuMyMessagesList: Array<MenuMyMessagesList> =
          myMessagesModel?.result?.menu_my_messages_list!;

        return menuMyMessagesList;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default MyMessagesProvider;
